import { Avatar, Tabs, Skeleton } from "antd";
import { get } from "lodash-es";
import { EllipsisText, Icon } from "@terminus/dqh-web-ui";
import { useCallback, useState, useEffect } from "react";
import { useMutation } from "@tanstack/react-query";
import { logout } from "@/services";
import { useCurrent } from "@/providers";
import styles from "./style.module.scss";
import CaModal from "@/components/caModal";
import type { CaModalListItem } from "@/components/caModal";
import { CustomButton } from "@/components";
import { Button } from "@terminus/dqh-web-ui";
import { useCustomerInfo } from "@/hooks";
import { cardGroupList, tabContentList } from "./config";
import { useCurrentPage } from "@/hooks";
import { useNavigate } from "react-router-dom";

export const Personal = () => {
  const { currentPage } = useCurrentPage();
  const [type, setType] = useState("supplier");
  const [showModal, setShowModal] = useState(false);
  useEffect(() => {
    if (currentPage === "business-opportunity") {
      setType("supplier");
    } else {
      setType("Purchaser");
    }
  }, [currentPage]);
  const {
    current: userInfo,
    isLogin,
    userInfoIsFetched,
    role,
    customerInfo,
  } = useCurrent();
  const { statusInfo } = useCustomerInfo();
  const onTypeChange = useCallback((v: string) => {
    setType(v);
  }, []);
  const handleLogin = useCallback(() => {
    if (isLogin) {
      return;
    }

    window.location.href = `${process.env.LOGIN_URL}?gotoUrl=${encodeURI(
      window.location.href,
    )}`;
  }, [isLogin]);

  const handleGoPlatform = useCallback(() => {
    if (!isLogin) {
      window.open(
        `${process.env.LOGIN_URL}?gotoUrl=${encodeURI(window.location.href)}`,
        "_blank",
      );
      return;
    }
    if (role === "buyer") {
      window.open(
        `${process.env.BUYER_WEB}/caigou-base-web/purchase_base_pc/workbench_home.htm`,
        "_blank",
      );
    } else {
      window.open(`${process.env.QCS_URL}/crm/index_html/home`, "_blank");
    }
  }, [role, isLogin]);

  const { mutate: logoutServer } = useMutation({
    mutationFn: logout,
  });

  const handleLogout = () => {
    logoutServer(
      { id: 1 },
      {
        onSuccess: () => {
          window.location.href = `${process.env.YCX_HOME}`;
        },
      },
    );
  };
  const navigate = useNavigate();

  const caModalList: CaModalListItem[] = [
    {
      icon: "https://public-daqihui-prod.oss-cn-hangzhou.aliyuncs.com/fe-resources/cxfe/statics/img/modalIconfir.png",
      label: "企业实名",
      desc: "实名认证 | 查看商机",
      buttonLabel: "立即认证",
      id: "authIdentity",
      clickFunc: () =>
        window.open(
          `${process.env.YCX_HOME}/go/portal/authIdentity`,
          "_blank",
        ),
    },
    {
      icon: "https://public-daqihui-prod.oss-cn-hangzhou.aliyuncs.com/fe-resources/cxfe/statics/img/modalIconsec.png",
      label: "认证企采商",
      desc: "专属身份 | CA证书 | 蚂蚁实力标 | 信用中国身份核验",
      buttonLabel: "立即购买",
      clickFunc: () =>
        window.open(
          `${process.env.YCX_HOME}/go/portal/e-goods?id=106`,
          "_blank",
        ),
      price: "¥200",
      id: "106",
    },
    {
      icon: "https://public-daqihui-prod.oss-cn-hangzhou.aliyuncs.com/fe-resources/cxfe/statics/img/modalIcontir.png",
      label: "高级企采商",
      desc: "专属身份 | CA证书 | 蚂蚁实力标 | 信用中国核验 | 企业联系方式查看 | 全网无限报价",
      buttonLabel: "立即购买",
      clickFunc: () =>
        window.open(
          `${process.env.YCX_HOME}/go/portal/e-goods?id=1`,
          "_blank",
        ),
      ribbon: "推荐",
      price: "¥6588",
      id: "1",
    },
  ];

  return (
    <>
      <CaModal open={showModal} onCancel={() => setShowModal(false)} list={caModalList} needSelect={false} />
      <div
        className={
          isLogin
            ? `${styles.personalWrapper} ${styles.personalWrapperLogin}`
            : styles.personalWrapper
        }
      >
        {isLogin ? (
          <div className={styles.personalWrapperLO} onClick={handleLogout}>
            <Icon style={{ marginTop: 0 }} name="tuichulogout"></Icon>
            <span style={{ marginLeft: 4 }}>退出登录</span>
          </div>
        ) : null}
        {userInfoIsFetched ? (
          <>
            <div
              className={styles.personalTop}
              style={{
                height: isLogin ? statusInfo?.height : 64,
                justifyContent: statusInfo?.justifyontent,
              }}
            >
              <div className={styles.personalTopAvatar}>
                <Avatar
                  size={32}
                  src="https://public-daqihui-prod.oss-cn-hangzhou.aliyuncs.com/fe-resources/cxfe/statics/img/daqihui-pc/default-avatar.png"
                />
              </div>
              <span className={styles.personalTopTitle}>
                <EllipsisText
                  text={
                    isLogin
                      ? get(customerInfo, "comName") ||
                        get(userInfo, "attributes.companyName") ||
                        get(userInfo, "account") ||
                        `你好，${type === "supplier" ? "供应商" : "采购商"}`
                      : `你好，${type === "supplier" ? "供应商" : "采购商"}`
                  }
                  style={{ textAlign: "center" }}
                />
              </span>
              {isLogin && (
                <span className={styles.personalTopTitleDesc}>
                  {get(userInfo, "account") ?? "欢迎来到大企汇"}
                </span>
              )}
            </div>
            {isLogin ? null : (
              <Button
                className={styles.personalTopLoginBtn}
                onClick={handleLogin}
                style={{ borderRadius: 4 }}
              >
                登录/注册
              </Button>
            )}

            {!isLogin && (
              <>
                <div className={styles.personalBot}>
                  <div className={styles.headerTab}>
                    <Tabs
                      activeKey={type}
                      onChange={onTypeChange}
                      items={[
                        {
                          label: type === "supplier" ? "我是供应商" : "供应商",
                          key: "supplier",
                        },
                        {
                          label: type === "Purchaser" ? "我是采购商" : "采购商",
                          key: "Purchaser",
                        },
                      ]}
                    />
                  </div>
                </div>
                <div className={styles.personalTypes}>
                  {type === "supplier" ? (
                    <>
                      <div
                        className={styles.personalTypesItem}
                        onClick={() => {
                          !isLogin
                            ? window.open(
                                `${process.env.LOGIN_URL}?gotoUrl=${encodeURI(
                                  window.location.href,
                                )}`,
                                "_blank",
                              )
                            : navigate("/subscription?type=ALL");
                        }}
                      >
                        <Icon name="shangjidingyue" size={32} />
                        <span className={styles.personalDesc}>商机订阅</span>
                      </div>
                      <div
                        className={styles.personalTypesItem}
                        onClick={() => {
                          !isLogin
                            ? window.open(
                                `${process.env.LOGIN_URL}?gotoUrl=${encodeURI(
                                  window.location.href,
                                )}`,
                                "_blank",
                              )
                            : (window.location.href = `${process.env.YCX_HOME}/buyer/businessCollection`);
                        }}
                      >
                        <Icon name="shoucang" size={32} />
                        <span className={styles.personalDesc}>收藏</span>
                      </div>
                      <div
                        className={styles.personalTypesItem}
                        onClick={() => {
                          !isLogin
                            ? window.open(
                                `${process.env.LOGIN_URL}?gotoUrl=${encodeURI(
                                  window.location.href,
                                )}`,
                                "_blank",
                              )
                            : (window.location.href = `${process.env.QCS_URL}/crm/index_html/bcp-crm/crm_opportunity_in_progress`);
                        }}
                      >
                        <Icon name="shangjigenjin" size={32} />
                        <span className={styles.personalDesc}>商机跟进</span>
                      </div>
                    </>
                  ) : (
                    <>
                      <div
                        className={styles.personalTypesItem}
                        onClick={() => {
                          window.open(
                            `${process.env.BUYER_WEB}/page/iframe.htm?menuCode=sourcing_purchase_list&`,
                            "_blank",
                          );
                        }}
                      >
                        <Icon name="xunyuan" size={32} />
                        <span className={styles.personalDesc}>寻源</span>
                      </div>
                      <div
                        className={styles.personalTypesItem}
                        onClick={() => {
                          window.open(
                            `${process.env.BUYER_WEB}/page/iframe.htm?menuCode=cg_b_order_list&`,
                            "_blank",
                          );
                        }}
                      >
                        <Icon name="dingdanlvyue" size={32} />
                        <span className={styles.personalDesc}>订单</span>
                      </div>
                      <div
                        style={{ width: 70 }}
                        className={styles.personalTypesItem}
                        onClick={() => {
                          window.open(
                            `${process.env.BUYER_WEB}/page/iframe.htm?menuCode=enterprise_supplier_list&`,
                            "_blank",
                          );
                        }}
                      >
                        <Icon name="gongyingshangguanli" size={32} />
                        <span className={styles.personalDesc}>供应商</span>
                      </div>
                    </>
                  )}
                </div>
              </>
            )}
            {["TO_AUDIT", "AUDIT_REJECT"]?.includes(
              customerInfo?.comAuditStatus,
            ) && (
              <div className={styles.cardGroup}>
                {cardGroupList?.map((item, index) => (
                  <div
                    key={index}
                    className={styles.cardGroupItem}
                    style={{ width: `${100 / cardGroupList.length}%` }}
                    onClick={() => {
                      window.open(item.url, "_blank");
                    }}
                  >
                    <img src={item.iconUrl} />
                    <span>{item.title}</span>
                  </div>
                ))}
              </div>
            )}
            {role === "buyer" && (
              <div
                className={styles.cardGroup}
                style={{ marginBottom: 12, marginTop: 12 }}
              >
                {tabContentList?.purchasingAgent?.map((item, index) => (
                  <div
                    key={index}
                    className={styles.cardGroupItem}
                    style={{
                      width: `${
                        100 / (tabContentList?.purchasingAgent?.length || 1)
                      }%`,
                    }}
                    onClick={() => {
                      window.open(item.successPath, "_blank");
                    }}
                  >
                    <img src={item.iconUrl || ""} alt={item.title || ""} />
                    <span>{item.title}</span>
                  </div>
                ))}
              </div>
            )}
            {role === "supplier" &&
              statusInfo?.enterStatus === "ENTER_PASS" && (
                <div className={styles.personalTypes}>
                  <div
                    className={styles.personalTypesItem}
                    onClick={() => {
                      window.open(
                        `${process.env.YCX_HOME}/subscription?type=0`,
                        "_blank",
                      );
                    }}
                  >
                    <Icon name="shangjidingyue" size={32} />
                    <span className={styles.personalDesc}>订阅</span>
                  </div>
                  <div
                    className={styles.personalTypesItem}
                    onClick={() => {
                      window.open(
                        `${process.env.YCX_HOME}/buyer/businessCollection`,
                        "_blank",
                      );
                    }}
                  >
                    <Icon name="shoucang" size={32} />
                    <span className={styles.personalDesc}>收藏</span>
                  </div>
                  <div
                    className={styles.personalTypesItem}
                    onClick={() => {
                      window.open(
                        `${process.env.QCS_URL}/crm/index_html/bcp-crm/crm_opportunity_in_progress`,
                        "_blank",
                      );
                    }}
                    // style={{ flex: "1 1 58px" }}
                  >
                    <Icon name="shangjigenjin" size={32} />
                    <span className={styles.personalDesc}>商机跟进</span>
                  </div>
                  <div
                    className={styles.personalTypesItem}
                    onClick={() => {
                      // window.open(
                      //   `${process.env.YCX_HOME}/recommend`,
                      //   "_blank"
                      // );
                      navigate("/recommend");
                    }}
                  >
                    <Icon name="recommend" size={32} />
                    <span className={styles.personalDesc}>推荐</span>
                  </div>
                </div>
              )}
            {isLogin &&
              statusInfo?.tip &&
              statusInfo?.tip !== "大企采工作台" && (
                <div className={styles.personalGoWrapper1}>
                  {statusInfo?.tipMessage && (
                    <div
                      className={styles.personalGoWrapperTip}
                      style={{
                        background: statusInfo?.mesColor?.[0],
                        color: statusInfo?.mesColor?.[1],
                      }}
                    >
                      {statusInfo?.tipMessage}
                    </div>
                  )}
                  <Button
                    type="default"
                    className={styles.personalGoWrapperBtn}
                    onClick={() => {
                      // 实名认证特殊处理，不直接跳转路由
                      // 又不要了
                      // if (statusInfo?.tip === "实名认证") {
                      //   setShowModal(true);
                      //   return;
                      // }
                      if (statusInfo?.route) {
                        window.open(statusInfo?.route, "_blank");
                        return;
                      }
                      handleGoPlatform();
                    }}
                    style={{ borderRadius: 4 }}
                  >
                    {statusInfo?.tip}
                  </Button>
                </div>
              )}
            {((isLogin &&
              ["buyer", "supplier"].includes(role) &&
              (statusInfo?.enterStatus === "ENTER_PASS" ||
                customerInfo?.comAuditStatus === "AUDIT_PASS")) ||
              !isLogin) && (
              <div
                className={styles.personalGoWrapper}
                onClick={handleGoPlatform}
              >
                <CustomButton
                  text={
                    isLogin
                      ? role === "buyer"
                        ? "大企采工作台"
                        : "企采商工作台"
                      : type === "supplier"
                      ? "企采商工作台"
                      : "大企采工作台"
                  }
                />
              </div>
            )}
          </>
        ) : (
          <div>
            <Skeleton loading={true} />
            <Skeleton loading={true} />
          </div>
        )}
      </div>
    </>
  );
};
// export const Personal = () => {
